import { render, staticRenderFns } from "./edit-client.vue?vue&type=template&id=74bc7fa0&"
import script from "./edit-client.vue?vue&type=script&lang=js&"
export * from "./edit-client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports